import { render, staticRenderFns } from "./MoleculeEditionBillingAcademySalesInvoice.vue?vue&type=template&id=ca8ceb26"
import script from "./MoleculeEditionBillingAcademySalesInvoice.vue?vue&type=script&lang=js"
export * from "./MoleculeEditionBillingAcademySalesInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports